import React from 'react';

const PillarCard = ({ icon, title, description }) => {
  return (
    <div className="pillar-card">
      <div className="pillar-icon">
        <span className="pillar-emoji">{icon}</span>
      </div>
      <h3 className="pillar-title">{title}</h3>
      <p className="pillar-description">{description}</p>
    </div>
  );
};

export default PillarCard;